import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './global';

createApp(App).use(router).mount(document.body);
